var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMailResourcesIcon = function SvgMailResourcesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32C7.178 32 0 24.822 0 16S7.178 0 16 0s16 7.178 16 16-7.178 16-16 16Zm8.297-10.38c.198 0 .358-.16.358-.357V11.218l-8.14 6.465a.827.827 0 0 1-1.03 0l-8.14-6.465v10.045c0 .197.16.358.358.358h16.594ZM23.05 10.38 16 15.977l-7.05-5.599h14.1Zm3.26.357v10.526c0 1.11-.903 2.013-2.013 2.013H7.703a2.015 2.015 0 0 1-2.013-2.013V10.737c0-1.11.903-2.013 2.013-2.013h16.594c1.11 0 2.013.903 2.013 2.013Z"
  })));
};
export default SvgMailResourcesIcon;